module.exports = __webpack_public_path__ + "static/rollerblade-9840d25aa486c5ae78c03755a51275b1.jpg";